export default __webpack_public_path__ + "static/media/bubbles-background.60773dd3.png";